import { APINotreNotaire } from '../helpers/AxiosAPI'

export const dossiersServices = {
    getDossiers,
}

function getDossiers() {
    return APINotreNotaire.get('get_user_folders')
}
